import DocsHome from './styled';

export default DocsHome;
